import { controlCharsObject } from "@quickpoint.me/shared";
import {
	type Dispatch,
	type ReactElement,
	type SetStateAction,
	createContext,
	useLayoutEffect,
	useState,
} from "react";
import { useRecoilValue } from "recoil";
import type { ElementProps } from "../../functionalComponents/RenderPage";
import type { GridObject } from "../../lib/calculateGridRowsAndColumns";
import { PageIndex, PageSizeAtom } from "../../state/page";
import DisplayGrid from "./DisplayGrid";
import RenderGrid from "./RenderGrid";

export const SplitPageContext = createContext(false);

function RenderSplitPage({
	pageSections,
	setGridHasRenderedCallback,
}: {
	pageSections: ReactElement<ElementProps>[][];
	setGridHasRenderedCallback?: Dispatch<SetStateAction<boolean>>;
}) {
	const [gridArray, setGridArray] = useState<GridObject[]>([]);
	const isInLandscape = useRecoilValue(PageSizeAtom).landscape;
	const pageIndex = useRecoilValue(PageIndex);

	useLayoutEffect(() => {
		const gArr: GridObject[] = [];
		pageSections.forEach((elArray, idx) => {
			const rows = elArray.filter(
				(el) => el.props.type === controlCharsObject["---"].controlChar,
			);
			let elArrayToUse = elArray;
			if (rows.length > 0) {
				const grid = (
					<DisplayGrid
						key={`styledGrid-${pageIndex}`}
						pageElementsToDisplay={elArray}
					/>
				);
				elArrayToUse = [grid];
			}

			gArr.push({
				col: isInLandscape ? idx + 1 : 1,
				row: isInLandscape ? 1 : idx + 1,
				maxCols: pageSections.length,
				maxRows: 1,
				isSplitCell: false,
				lastRowInGrid: true,
				elArray: elArrayToUse,
				lastColInRow: idx + 1 === pageSections.length,
			});

			setGridArray(gArr);
		});
	}, [pageSections, isInLandscape, pageIndex]);

	return (
		<SplitPageContext.Provider value={true}>
			<RenderGrid
				gridArray={gridArray}
				alignCellsAsColumn={true}
				setGridHasRenderedCallback={setGridHasRenderedCallback}
				isSplitPageChild={true}
			/>
		</SplitPageContext.Provider>
	);
}

export default RenderSplitPage;
